'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaults = {
  // 请求的类型，可以是 `get`, `post`, `delete`, `put` 等等，大小写不敏感
  method: 'get', // default `get`

  // response 数据类型，可以是 `json`, `jsonp`, `document`, `text`
  // 除了 `jsonp` 之外，其他的其实就是请求头部的 `Accept`
  type: 'json', // default `json`

  // request 的数据类型，可以是 `application/json`, `application/x-www-form-urlencoded` 等等
  // 其实就是请求头部的 `Content-Type`
  // 注意：`application/x-www-form-urlencoded` 时会把 `data` 转化成 `query string`
  contentType: 'application/json', // default `application/json`,

  // CORS 跨域的时候是否启用 `credentials`
  // 简单的说就是跨域的时候是否携带 `cookie` 等等认证信息，具体参考：
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Access-Control-Allow-Credentials
  withCredentials: false, // default `false`

  // 超时时间
  timeout: 5000, // default 5000

  // 是否开启 retcode
  enableRetCode: false,

  // 是否开启 enableCsrf
  enableCsrf: false,

  // 是否处理过期 session
  autoHandleSessionExpire: false,

  // 请求头
  headers: {}
};

exports.default = defaults;